import { objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties } from '../_virtual/_rollupPluginBabelHelpers.mjs';
import { safeLocalStorage, safeSessionStorage } from '../storage.mjs';
import { NumberTypedStorage } from './storages/NumberTypedStorage.mjs';
import { TypedStorage } from './storages/TypedStorage.mjs';

var _excluded = ["initialValue"];

function createTypedStorage(key) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var initialValue = options.initialValue,
      others = _objectWithoutProperties(options, _excluded);

  if (typeof initialValue === 'number') {
    return new NumberTypedStorage(key, _objectSpread2(_objectSpread2({}, others), {}, {
      initialValue: initialValue
    }));
  }

  return new TypedStorage(key, options);
}

function createTypedLocalStorage(key) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return createTypedStorage(key, _objectSpread2(_objectSpread2({}, options), {}, {
    storage: safeLocalStorage
  }));
}
function createTypedSessionStorage(key) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return createTypedStorage(key, _objectSpread2(_objectSpread2({}, options), {}, {
    storage: safeSessionStorage
  }));
}

export { createTypedLocalStorage, createTypedSessionStorage };
